module.exports = __webpack_public_path__ + "static/media/blackjack_lobby.05728325.jpg";